import type { SVGProps } from "react";
export interface EyeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EyeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EyeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.997 2.875c3.49 0 6.038 1.56 7.787 3.334 1.73 1.757 2.708 3.75 3.129 4.749a2.67 2.67 0 0 1 0 2.083c-.421 1-1.398 2.993-3.13 4.75-1.748 1.775-4.296 3.334-7.786 3.334s-6.037-1.56-7.784-3.335c-1.73-1.758-2.708-3.752-3.128-4.75a2.67 2.67 0 0 1 0-2.08c.42-1 1.397-2.992 3.128-4.75 1.747-1.775 4.293-3.335 7.784-3.335m0 2.25c-2.748 0-4.748 1.206-6.182 2.663-1.451 1.475-2.292 3.18-2.656 4.044a.42.42 0 0 0 0 .336l.159.362c.424.925 1.228 2.391 2.497 3.68 1.434 1.458 3.434 2.665 6.182 2.665 2.747 0 4.748-1.206 6.183-2.663 1.452-1.474 2.296-3.18 2.66-4.044a.42.42 0 0 0 0-.335c-.364-.865-1.208-2.57-2.66-4.045-1.435-1.457-3.436-2.663-6.183-2.663"
      />
      <path
        fill={color}
        d="M14.874 12a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m2.25 0a5.124 5.124 0 0 1-10.249 0 5.126 5.126 0 0 1 10.25 0Z"
      />
    </svg>
  );
}
